import { Component, OnInit, Input } from '@angular/core';
import { Quotes } from '@models/models';

@Component({
	selector: 'quote-assignment-panel',
	template: require('./quote-assignment-panel.component.html'),
	styles: [require('./quote-assignment-panel.component.scss')]
})
export class QuoteAssignmentPanelComponent implements OnInit {
	@Input('data') data: Quotes;
	@Input() isQuote: boolean;
	@Input('isFixed') isFixed: boolean;

	contractName = 'None';
	questionnaireName = 'None';
	paymentScheduleName = 'None';

	constructor() {}

	ngOnInit(): void {
		this.setAssignmentNames();
	}

	setAssignmentNames(): void {
		const { contract, questionnaire, paymentSchedule } = this.data;

		if (contract !== null) {
			this.contractName = contract.name;
		}
		if (questionnaire !== null) {
			this.questionnaireName = questionnaire.name;
		}
		if (paymentSchedule !== null) {
			this.paymentScheduleName = paymentSchedule.name;
		}
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=kkml25e9zf!./web/modern/components/quote/quote-assignment-panel/quote-assignment-panel.component.ts